export default __webpack_public_path__ + "static/media/stripe.2d829ccf.jpeg";